<template>
	<div
		:class="[
			'option',
			{'is-header' : isHeader},
			{'is-hovered' : isHovered}
		]"
		:data-id="dataId"
		@mouseover="$emit('mouseover')"
		@mouseout="$emit('mouseout')"
	>
			<!-- :class="[
				{'remove-tp' : removeTopPadding}
			]" -->
		<div
			class="container"
		>

			<!-- Icon -->
			<div class="icon" v-if="hasIcon">
				<div class="icon-image">
					<slot name="icon"/>
				</div>
				<div v-if="hasIconCaption" class="icon-caption">
					<slot name="iconCaption"/>
				</div>
			</div>

			<!-- Main content -->
			<div class="content type--s">
				<p class="body type--b">{{ primary }}</p>
				<p class="caption">{{ secondary }}</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SelectOption",

	props: {
		primary: { type: String, default: "" },
		secondary: { type: String, default: "" },
		dataId: { type: Number },
		isHeader: { type: Boolean, default: false },
		isHovered: { type: Boolean, default: false },
		removeTopPadding: { type: Boolean, default: false }
	},

	computed: {
		hasIcon() {
			return !!this.$slots.icon
		},
		hasIconCaption() {
			return !!this.$slots.iconCaption
		},
	},
}
</script>

<style lang="scss" scoped>
.option {
	background: #fff;
	border-bottom: 1px solid $colour-pencil--lightest;
	cursor: pointer;
	transition: background-color 150ms;
	width: 100%;

	// Teal header
	&.is-header {
		background: $colour-teal;
		cursor: default;
	}

	// Hover effect, not on header
	&:not(.is-header):hover,
	&:not(.is-header).is-hovered {
		background: $colour-teal--bright;
		transition: background-color 75ms;
	}
}

.container {
	display: flex;
	flex-direction: row;
	padding: 0.75rem;
}
.remove-tp {
	padding-top: 0;
}

.icon {
	color: $colour-teal;
	display: flex;
	flex: 0 0 2.5rem;
	flex-direction: column;
	margin-right: 0.75rem;
	text-align: center;
	.is-header & {
		color: #fff;
	}
}

.icon-image {
	height: auto;
	margin: 0.125rem auto 0;
	width: 1.5rem;
	svg {
		display: block;
		fill: currentColor;
		height: auto;
		width: 100%;
	}
}

.icon-caption {
	line-height: 1;
}

.content {
	line-height: 1.25;
}

.body {
	display: block;
	margin: 0 0 0.125rem;
	width: 100%;
	.is-header & {
		color: #fff;
		font-weight: bold;
	}
}

.caption {
	color: $colour-pencil;
	display: block;
	width: 100%;
	.is-header & {
		color: #fff;
	}
}
</style>
